import { render, staticRenderFns } from "./req-forms-statistic.vue?vue&type=template&id=adf542f0&scoped=true"
import script from "./req-forms-statistic.vue?vue&type=script&lang=js"
export * from "./req-forms-statistic.vue?vue&type=script&lang=js"
import style0 from "./req-forms-statistic.vue?vue&type=style&index=0&id=adf542f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf542f0",
  null
  
)

export default component.exports